import { cond, equals, mergeDeepRight } from 'ramda';

import { ChartSvg } from './base';
import { renderWhenTrue } from '../../utils/rendering';
import { ELEMENTS } from './axes/axes.constants';

const { TOP, BOTTOM, LEFT, RIGHT } = ELEMENTS;

export const ChartsMixin = {
  components: { ChartSvg },
  props: {
    data: Object,
    config: Function,
    parser: Function,
    paddingTop: { type: Number, required: false },
    paddingRight: { type: Number, required: false },
    paddingBottom: { type: Number, required: false },
    paddingLeft: { type: Number, required: false },
  },
  data() {
    return {
      calculatedLeftSpace: 20,
      calculatedRightSpace: 20,
      calculatedTopSpace: 20,
      calculatedBottomSpace: 20,
      hover: null,
    };
  },
  computed: {
    chartData() {
      return this.parser ? this.parser(this.data) : this.data;
    },
    baseChartConfig() {
      return {};
    },
    chartConfig() {
      const config = this.config ? this.config(this.chartData, this) : {};

      const chartConfig = mergeDeepRight(this.baseChartConfig, config);

      this.extendConfig && this.extendConfig(chartConfig);

      return chartConfig;
    },
    leftSpace: {
      get() {
        if (typeof this.paddingLeft !== 'undefined') {
          return this.paddingLeft;
        }

        return this.calculatedLeftSpace;
      },
      set(value) {
        this.calculatedLeftSpace = value;
      },
    },
    rightSpace: {
      get() {
        if (typeof this.paddingRight !== 'undefined') {
          return this.paddingRight;
        }

        return this.calculatedRightSpace;
      },
      set(value) {
        this.calculatedRightSpace = value;
      },
    },
    topSpace: {
      get() {
        if (typeof this.paddingTop !== 'undefined') {
          return this.paddingTop;
        }

        return this.calculatedTopSpace;
      },
      set(value) {
        this.calculatedTopSpace = value;
      },
    },
    bottomSpace: {
      get() {
        if (typeof this.paddingBottom !== 'undefined') {
          return this.paddingBottom;
        }

        return this.calculatedBottomSpace;
      },
      set(value) {
        this.calculatedBottomSpace = value;
      },
    },
    chartWidth() {
      return this.parentWidth - this.leftSpace - this.rightSpace;
    },
    chartHeight() {
      return this.parentHeight - this.topSpace - this.bottomSpace;
    },
  },
  methods: {
    setSpace(type, space) {
      cond([
        [
          equals(TOP),
          () => {
            this.topSpace = space;
          },
        ],
        [
          equals(BOTTOM),
          () => {
            this.bottomSpace = space;
          },
        ],
        [
          equals(LEFT),
          () => {
            this.leftSpace = space;
          },
        ],
        [
          equals(RIGHT),
          () => {
            this.rightSpace = space;
          },
        ],
      ])(type);
    },
    handleMouseOver(data, chart) {
      return event => {
        this.chartConfig.handleMouseOver({ data, chart, event });
      };
    },
    handleMouseOut(data, chart) {
      return event => {
        this.chartConfig.handleMouseOut({ data, chart, event });
      };
    },
    handleClick(data, chart) {
      return event => {
        this.chartConfig.handleClick({ data, chart, event });
      };
    },
    renderHover() {
      return renderWhenTrue(() => {
        const HoverComponent = this.hover.component;

        return <HoverComponent />;
      })(!!this.hover);
    },
  },
};
